import DevelopingBackground from "assets/images/background/develop-bg.png";
import { Modal } from "antd";
import { useEffect, useState } from "react";

interface DevelopingModalProps {
  isOpen: boolean;
  onChange: Function;
  title?: string;
  content?: string;
}

const DevelopingModal = (props: DevelopingModalProps) => {
  const {
    isOpen,
    onChange,
    title = "Tính năng đang được cập nhật",
    content = "Xin lỗi, tính năng này hiện đang trong quá trình phát triển. Bạn vui lòng thử lại sau!",
  } = props;
  const [interval, setModalInterval] = useState(10);

  useEffect(() => {
    if (isOpen) {
      const intervalId = setInterval(() => {
        if (interval > 0) {
          setModalInterval((prev) => --prev);
        } else {
          clearInterval(intervalId);
          setModalInterval(10);
          onChange(false);
        }
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval, isOpen]);

  return (
    <Modal
      centered
      open={isOpen}
      onCancel={() => {
        onChange(false);
        setModalInterval(10);
      }}
      footer={null}
      className="rounded-xl"
    >
      <div className="h-[400px] flex flex-col items-center justify-center lg:px-6 lg:py-4 relative">
        <div className="w-full h-full relative">
          <img src={DevelopingBackground} alt="" className="p-5 lg:p-10 object-contain" />
        </div>
        {title && (
          <p
            className="text-dark text-center text-md lg:text-lg mb-2"
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          ></p>
        )}
        {content && (
          <p
            className="text-dark text-center leading-6 text-sm lg:text-md"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          ></p>
        )}
        <div
          style={{
            width: `${interval * 10}%`,
          }}
          className="h-[5px] rounded-lg bg-primary mt-4 duration-1000 ease-linear self-start"
        ></div>
      </div>
    </Modal>
  );
};

export default DevelopingModal;
